const permissionMixin = {
    methods: {
        hasPermission({ requiredPermissions, operator = "AND", redirectUrl }) {
            let permissions = localStorage.getItem("roles");
            if (!permissions) {
                if (redirectUrl) {
                    this.$router.push(redirectUrl);
                }
                return false;
            }
            permissions = JSON.parse(permissions);
            let result = operator === "AND" ? true : false;
            for (const requiredPermission of requiredPermissions) {
                if (operator === "AND" && !permissions.includes(requiredPermission)) {
                    result = false;
                    break;
                }
                if (operator === "OR" && permissions.includes(requiredPermission)) {
                    result = true;
                    break;
                }
            }
            if (!result && redirectUrl) {
                this.$router.push(redirectUrl);
            }
            return result;
        },
    },
};
export default permissionMixin;


// WEBPACK FOOTER //
// ./src/components/Permissions/permissionMixin.js